import React, { useState, useEffect } from 'react';
import { Button } from '@instructure/ui';
import { useTrackToggle } from '@livekit/components-react';
import { getSourceIcon } from './util';

export const TrackToggle = ({ showIcon, ...props }) => {
  const { buttonProps, enabled } = useTrackToggle(props);
  // If showIcon is undefined, default to true
  const displayIcon = showIcon !== undefined ? showIcon : true;

  return (
    <Button
      size="small"
      renderIcon={displayIcon && getSourceIcon(props.source, enabled)}
      withBackground={props.isEnabled ? true : false}
      color={props.isEnabled ? 'success' : 'secondary'}
      themeOverride={{
        borderWidth: 0,
      }}
      {...buttonProps}
    >
      {props.children}
    </Button>
  );
};
